/**
 * REAL CUSTOMER REVIEWS ONLY.
 *
 * Nothing here is invented. Each entry is an empty slot waiting for a real
 * review asset (screenshot or customer photo) plus its original text.
 *
 * To publish a review, fill in the fields on one slot:
 *   image  -> URL of the REAL screenshot / customer photo (do not retouch it)
 *   text   -> the review copy EXACTLY as the customer wrote it
 *   name   -> the customer's original identifier, only if it really exists
 *   stars  -> only if a star rating was actually given
 *   date   -> only if the original review shows one
 *   source -> e.g. "Original review from the marketplace listing" when the
 *             review did not come from our own store. Never label a review
 *             "Verified Customer" unless it can genuinely be verified.
 *
 * Slots that are still empty render as a clearly marked placeholder and are
 * never presented to visitors as a real testimonial.
 */

export type Review = {
  id: string
  /** Editorial guidance for which real review belongs in this slot. */
  slotHint: string
  image: string | null
  text: string | null
  name: string | null
  stars: number | null
  date: string | null
  source: string | null
  verified: boolean
}

const emptySlot = (id: string, slotHint: string): Review => ({
  id,
  slotHint,
  image: null,
  text: null,
  name: null,
  stars: null,
  date: null,
  source: null,
  verified: false,
})

export const reviews: Review[] = [
  emptySlot('r1', 'Pair 1 · Strongest emotional transformation'),
  emptySlot('r2', 'Pair 1 · Child holding a finished animal craft'),
  emptySlot('r3', 'Pair 2 · Child proudly showing a completed project'),
  emptySlot('r4', 'Pair 2 · Photo of several finished models'),
  emptySlot('r5', 'Pair 3 · Kept the child busy and entertained'),
  emptySlot('r6', 'Pair 3 · Child asked to build another one'),
  emptySlot('r7', 'Pair 4 · Screen-free afternoon'),
  emptySlot('r8', 'Pair 4 · Finished vehicle craft'),
  emptySlot('r9', 'Pair 5 · Variety — printing more projects'),
  emptySlot('r10', 'Pair 5 · Ease of printing at home'),
]
